import { baseApi } from "../api/baseApi";

export const rolePrivilegesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAssignedRolePrivileges: build.query({
      query: () => ({
        url: "/api/role-privileges",
        method: "GET",
      }),
      transformResponse: (response) => (Array.isArray(response) ? response : []),
      providesTags: ["RolePrivileges"],
    }),
    getPrivilegeCatalog: build.query({
      query: () => ({
        url: "/api/role-privileges/privileges",
        method: "GET",
      }),
      transformResponse: (response) => (Array.isArray(response) ? response : []),
      providesTags: ["RolePrivilegeCatalog"],
    }),
    getAssignableEmployees: build.query({
      query: () => ({
        url: "/api/role-privileges/assignable-employees",
        method: "GET",
      }),
      transformResponse: (response) => (Array.isArray(response) ? response : []),
      providesTags: ["AssignableEmployees"],
    }),
    createPrivilege: build.mutation({
      query: (body) => ({
        url: "/api/role-privileges/privileges",
        method: "POST",
        body,
      }),
      invalidatesTags: ["RolePrivileges", "RolePrivilegeCatalog"],
    }),
    createRole: build.mutation({
      query: (body) => ({
        url: "/api/role-privileges/roles",
        method: "POST",
        body,
      }),
      invalidatesTags: ["RolePrivileges", "AssignableEmployees"],
    }),
    assignPrivilegeToRole: build.mutation({
      query: ({ roleId, privilegeId }) => ({
        url: `/api/role-privileges/roles/${roleId}/privileges`,
        method: "POST",
        body: { privilegeId },
      }),
      invalidatesTags: ["RolePrivileges"],
    }),
    assignEmployeeToRole: build.mutation({
      query: ({ roleId, empId }) => ({
        url: `/api/role-privileges/roles/${roleId}/employees`,
        method: "POST",
        body: { empId },
      }),
      invalidatesTags: ["RolePrivileges"],
    }),
    removePrivilegeFromRole: build.mutation({
      query: ({ roleId, privilegeId }) => ({
        url: `/api/role-privileges/roles/${roleId}/privileges/${privilegeId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["RolePrivileges"],
    }),
    removeEmployeeFromRole: build.mutation({
      query: ({ roleId, empId }) => ({
        url: `/api/role-privileges/roles/${roleId}/employees/${empId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["RolePrivileges", "AssignableEmployees"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAssignedRolePrivilegesQuery,
  useGetPrivilegeCatalogQuery,
  useGetAssignableEmployeesQuery,
  useCreatePrivilegeMutation,
  useCreateRoleMutation,
  useAssignPrivilegeToRoleMutation,
  useAssignEmployeeToRoleMutation,
  useRemovePrivilegeFromRoleMutation,
  useRemoveEmployeeFromRoleMutation,
} = rolePrivilegesApi;
